import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LobbyView from '../views/LobbyView.vue'
import { useStateStore } from '@/stores/state.store';
import { storeToRefs } from 'pinia';

// TikTok browser detection function
const isTikTokBrowser = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes('tiktok') || ua.includes('bytedance');
};

// Temporary redirect to static Lobby Page, not yet implemented in Vue Router
// (more changes to products / cart views required)
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: {
        mounted() {
          if (document.domain == 'app.wyrld.de' && !document.cookie.includes('access')) {
            //window.location.replace('https://wyrld.de')
            //return;
          }
          window.location.replace('/home/')
        },
        template: '<div></div>'
      }
    },
    {
      path: '/oldlobby',
      name: 'home',
      component: HomeView,
      meta: {
        backgroundColor: 'rgba(36, 38, 53, 1)',
      }
    },
    {
      path: '/lobby',
      name: 'lobby',
      component: LobbyView,
      meta: {
        disableHeader: false,
        xxxbackgroundColor: 'rgba(236, 38, 53, 1)',
      }
    },
    {
      path: '/influencer/:handle',
      name: 'InfluencerView',
      component: () => import('../views/InfluencerView.vue'),
      meta: {
        backgroundColor: 'rgba(36, 38, 53, 1)',
        cartType: 'dark'
      }
    },
    {
      path: '/bev/:room_id',
      name: 'BirdsEyeView',
      component: () => import('../views/BirdsEyeView.vue'),
      meta: {
        cartOffset: '0px',
        logoColor: 'white',
        backgroundColor: 'transparent',
        disableHeader: false,
        disableCart: false
      }
    },
    {
      path: '/static/:room_id',
      name: 'StaticBirdsEyeView',
      component: () => import('../views/BirdsEyeView.vue'),
      meta: {
        cartOffset: '0px',
        logoColor: 'white',
        backgroundColor: 'transparent',
        disableHeader: false,
        disableCart: false
      }
    },
    {
      path: '/products',
      name: 'ProductListView',
      component: () => import('../views/ProductListView.vue'),
      meta: {
        backgroundColor: '#fff',
        cartType: 'dark'
      }
    },
    {
      path: '/room/:room_id',
      name: 'RoomView',
      component: () => {
        // Use BirdsEyeView for TikTok browser, RoomView for others
        return isTikTokBrowser() 
          ? import('../views/BirdsEyeView.vue')
          : import('../views/RoomView.vue');
      },
      meta: () => {
        // Use BirdsEyeView meta settings for TikTok browser
        if (isTikTokBrowser()) {
          return {
            cartOffset: '0px',
            logoColor: 'white',
            backgroundColor: 'transparent',
            disableHeader: false,
            disableCart: false
          };
        } else {
          // Original RoomView meta settings for other browsers
          return {
            disableHeader: true,
            disableCart: true
          };
        }
      }
    },
    {
      path: '/product/:handle',
      name: 'ProductView',
      component: () => import('../views/ProductView.vue'),
      meta: {
        backgroundColor: 'white',
        cartOffset: '80px',
        cartType: 'dark'
      }
    },
    {
      path: '/hilfe',
      name: 'HelpView',
      component: () => import('../views/HelpView.vue')
    },
    {
      path: '/impressum',
      name: 'Imprint',
      component: () => import('../views/ImprintView.vue')
    },
    {
      path: '/datenschutz',
      name: 'DataProtection',
      component: () => import('../views/DataProtectionView.vue')
    },
    {
      path: '/terms',
      name: 'TermsOfService',
      component: () => import('../views/TermsOfServiceView.vue')
    },
    {
      path: '/games',
      name: 'games',
      children: [
        {
          path: 'flapper',
          name: 'gamesFlapper',
          component: () => import('../views/games/FlapperView.vue'),
          meta: {
            disableCart: true,
            backgroundColor: 'rgba(36, 38, 53, 0)',
          }
        },
        {
          path: 'jumper',
          name: 'gamesJumper',
          component: () => import('../views/games/JumperView.vue'),
          meta: {
            disableCart: true,
            backgroundColor: 'rgba(36, 38, 53, 1)',
          }
        }
      ]
    },
    {
      path: '/debug',
      name: 'debug',
      children: [
        {
          path: 'games',
          children: [
            {
              path: 'jumper',
              name: 'debugGameJumper',
              component: () => import('../views/Debug/DebugGameJumper.vue'),
              meta: {
                disableHeader: true,
                disableCart: true
              }
            },
            {
              path: 'flapper',
              name: 'debugGameFlapper',
              component: () => import('../views/Debug/DebugGameFlapper.vue'),
              meta: {
                disableHeader: true,
                disableCart: true
              }
            }
          ]
        },
        {
          path: 'error',
          name: 'debugError',
          component: () => import('../views/Debug/DebugErrorView.vue')
        },
        {
          path: '',
          name: 'debugHome',
          component: () => import('../views/DebugView.vue')
        },
        {
          path: 'products',
          component: () => import('../views/Debug/DebugProductsView.vue')
        },
        {
          path: 'product/:product_id',
          component: () => import('../views/Debug/DebugProductView.vue')
        },
        {
          path: 'influencer',
          component: () => import('../views/Debug/DebugInfluencerView.vue')
        },
        {
          path: 'inputs',
          component: () => import('../views/Debug/DebugInputsView.vue')
        },
        {
          path: 'buttons',
          component: () => import('../views/Debug/DebugButtonsView.vue')
        },
        {
          path: 'sidesheets',
          component: () => import('../views/Debug/DebugSideSheetsView.vue')
        },
        {
          path: 'product3d',
          component: () => import('../views/Debug/DebugProduct3DView.vue')
        },
        {
          path: 'room',
          name: 'debugRoom',
          component: () => import('../views/Debug/DebugRoomView.vue'),
          meta: {
            disableHeader: true
          }
        }
      ]

    }
  ]
});


router.afterEach(() => {
  const state = useStateStore()
  const { navigationOpen, sideSheetOpen } = storeToRefs(state)
  navigationOpen.value = false
  sideSheetOpen.value = false
})

// router.beforeEach((to, from) => {
//   console.log('beforeEach', to, from);
//   const state = useStateStore();
//   state.sideSheetOpen = false;

//   if (state.selectedProduct) {
//     state.popProduct();
//     // going to the cart from the product detail page should still be possible in one navigation step
//     return (to.query.cart === null);
//   }

//   if(to.path !== from.path) {
//     state.popProduct();
//   }
// });

export default router
